import axios from "axios"
import crypto from "crypto"

export const subscriptionAPI = axios.create({
	baseURL: process.env.VUE_APP_API_SERVER_URI,
	withCredentials: true,
})

subscriptionAPI.interceptors.request.use(
	(config) => {
		const date = new Date()
		const timestamp =
			date.getUTCFullYear().toString() +
			date.getUTCMonth() +
			1 +
			date.getUTCDate() +
			date.getUTCHours() +
			date.getUTCMinutes() +
			date.getUTCSeconds() +
			date.getUTCMilliseconds()

		const payload = process.env.VUE_APP_API_KEY + timestamp

		const decodedSecret = process.env.VUE_APP_SECRET_KEY

		const hmac = crypto.createHmac("sha256", decodedSecret)

		const signed = hmac.update(payload).digest("hex")

		config.headers.common["X-APP-ID"] = `${process.env.VUE_APP_ID}`
		config.headers.common["X-API-TIMESTAMP"] = `${timestamp}`
		config.headers.common["Content-Type"] = `application/json`
		config.headers.common["X-API-HASH"] = `${signed}`

		return config
	},
	(error) => Promise.reject(error)
)
